import {buildStateEvent, GenericStateEvent} from '../../common-redux'

export interface NotifyStateEvent<T> extends GenericStateEvent<T> {}

export const UpdateNotifySuccessEvent = {
    type: 'UpdateNotifySuccessEvent',
    build: (payload: number) => buildStateEvent(UpdateNotifySuccessEvent.type, payload)
}
